import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as actions from '../redux/actions';
import CustomLoader from '../../common/CustomLoader';
import ParentDocCard from '../../common/ParentDocCard';
import { collectionItemText } from '../../../common/docs/content';
import ParentContentCard from '../../common/ParentContentCard';
import CustomRadio from '../../../common/ui/CustomRadio';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export class CollectionDump extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    dumpType: '',
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }
  handleCancel = () => {
    let { collectionTitle } = this.props.collections.selectedCollection;
    collectionTitle = collectionTitle.toLowerCase();
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionTitle}`,
    );
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleSubmit = () => {
    if (!this.state.dumpType) {
      toast.error(`Error: Please select export format type`, {});
      return '';
    }
    const { match } = this.props;
    const { projectId, collectionId, version } = match.params;
    const header = builderSurfaceJsonContentHeader(projectId);
    axios({
      url: `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/dump/${collectionId}/type/${this.state.dumpType}`,
      method: 'POST',
      headers: header.headers,
      responseType: 'blob', // important
    }).then((response) => {
      const { data, headers } = response;
      if (headers['content-disposition']) {
        const fileName = headers['content-disposition'].replace(/\w+; filename="(.*)"/, '$1');
        if (data) {
          const url = window.URL.createObjectURL(
            new Blob([data], { type: headers['content-type'] }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }
      }
    });
  };

  renderCollectionDetail = () => {
    const { collections } = this.props;
    const { dumpType } = this.state;
    const { selectedCollection, loadProjectCollectionDetailPending } = collections;
    if (selectedCollection) {
      return (
        <div className="row mx-auto">
          <ParentContentCard
            title={`${selectedCollection.collectionTitle}'s Dump`}
            icon="dbExport"
            handleCancel={this.handleCancel}
          >
            <div className="row">
              <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-4">
                <label className="ml-4">Dump Export Format {dumpType}</label>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div className="form-check px-3 mx-3">
                  <select
                    name="dumpType"
                    id="dumpType"
                    className="form-control"
                    onChange={this.handleChange}
                    value={dumpType}
                  >
                    <option value="">- Select Format -</option>
                    <option value="CSV">CSV</option>
                    <option value="JSON">JSON</option>
                    <option value="MONGO_DUMP">Mongo Query</option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <button
                  className="btn btn-theme-submit"
                  onClick={this.handleSubmit}
                  disabled={!dumpType ? 'disabled' : ''}
                >
                  <i className={`wb ${drapcodeIcon('install')}`}></i>
                  &nbsp; Export Dump &nbsp;
                </button>
              </div>
            </div>
          </ParentContentCard>
          <ParentDocCard>
            <h5>
              <b>About Collection Data</b>
            </h5>
            <p>{collectionItemText}</p>
          </ParentDocCard>
        </div>
      );
    } else if (loadProjectCollectionDetailPending) {
      return '';
    } else {
      return 'No Collection Found';
    }
  };

  render() {
    const { collections, actions, match } = this.props;
    const { projectId, collectionId, collectionName } = match.params;
    const { dumpType } = this.state;
    const { loadProjectCollectionDetailPending, selectedCollection } = collections;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}
            {this.renderCollectionDetail()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDump);
